import { Provider } from '@angular/core';

import { UserService } from '@core/services/user.service';
import { APP_STORE } from '@core/stores/app.store';
import { USER_STORE } from '@core/stores/user.store';

export const CORE_PROVIDERS: Provider[] = [UserService, USER_STORE, APP_STORE];
